import CustomCheckbox from '@src/components/CustomCheckbox';
import CustomImage from '@src/components/CustomImage';
import CustomTooltip from '@src/components/CustomTooltip';
import iconWarning from '@src/assets/icons/icon-dikkat.svg';

import { Text } from '@src/components';

export function HasMobilePaymentComponent(record) {
  return (props) => {
    return (
      <CustomTooltip
        placement="left"
        overlayInnerStyle={{ width: '232px', height: '57px', borderRadius: '5px' }}
        title={
          record?.cardType &&
          record?.hasMobilePayment && (
            <div style={{ display: 'flex' }}>
              <CustomImage style={{ margin: '3px 11px 14px 0' }} src={iconWarning} />
              <span>
                {' '}
                <Text t="mobilePaymentPermissionCannotBeRemovedForDigital" />
              </span>
            </div>
          )
        }
        trigger="hover"
      >
        <CustomCheckbox
          id="ticketRestaurant-mangeMyCards-activeCardlist-hasMobilePaymentComponent-checkbox"
          disabled={!!(record?.cardType && record?.hasMobilePayment)}
          {...props}
        />
      </CustomTooltip>
    );
  };
}
